module.exports = "/_next/static/images/40883557486fd05e9c812f5a4d0486b7-cajita-lg.png";